// 회원 등록

import { useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useJoinCreate } from "./handlers";
import { PiEyeClosed } from "react-icons/pi";
import { IoMdEye } from "react-icons/io";
import { regPwd } from "components/utils/comm";
import AllCheck from "./allCheck";
import "./create.scss";
import Input from "components/input";

export default function JoinCreatePage() {
  const { t } = useTranslation();
  const formRef = useRef<HTMLFormElement>(null);
  const txtRef = useRef<HTMLHeadingElement>(null);
  const [isShow, setIsShow] = useState({
    lgnPwd: false,
    check: false,
  });
  const { onSubmit } = useJoinCreate();

  useLayoutEffect(() => {
    if (txtRef.current) {
      txtRef.current.innerHTML = t("pass_regi_text_1_join");
    }
  }, [t]);

  return (
    <>
      <form id="join-form" ref={formRef} onSubmit={onSubmit}>
        <h2>{t("pass_regi_join")}</h2>
        <div className="pt-3">
          <h4 className="leading-[24px] dashed-b-1 pb-4" ref={txtRef} />
        </div>
        <ul className="lex col gap-3 pt-6">
          <li className="relative flex items-end">
            <span
              className="mt-[-10px] absolute right-4 top-3"
              onClick={() => {
                setIsShow({
                  ...isShow,
                  lgnPwd: !isShow.lgnPwd,
                });
              }}
            >
              {!isShow.lgnPwd && <PiEyeClosed size={16} />}
              {isShow.lgnPwd && <IoMdEye size={16} />}
            </span>
            <label htmlFor="">{t("lbl_pw_cmm")}</label>
            <Input
              type={isShow.lgnPwd ? "text" : "password"}
              name="lgnPwd"
              className="w-full bg-transparent border-0 border-b-1"
              required
              data-type="C"
              onBlur={(e) => {
                const value = e.currentTarget.value;
                if (!regPwd.test(value)) {
                  e.currentTarget.style.color = "red";
                  e.currentTarget.setCustomValidity(
                    "정확환 형식의 비밀번호를 입력하세요."
                  );
                  return;
                }
                if (regPwd.test(value)) {
                  e.currentTarget.style.color = "#010101";
                }
              }}
              onChange={() => {}}
              validatyTxt="비밀번호를 입력하여 주세요."
            />
          </li>
          <li className="relative flex items-end">
            <span
              className="mt-[-10px] absolute right-4 top-3"
              onClick={() => {
                setIsShow({
                  ...isShow,
                  check: !isShow.check,
                });
              }}
            >
              {!isShow.check && <PiEyeClosed size={16} />}
              {isShow.check && <IoMdEye size={16} />}
            </span>
            <label htmlFor="">{t("lbl_pw_chk_cmm")}</label>
            <Input
              type={isShow.check ? "text" : "password"}
              name="lgnPwd_check"
              className="w-full bg-transparent border-0 border-b-1"
              required
              dataTyp="R"
              //   data-type="C"
              onBlur={(e) => {
                const value = e.currentTarget.value;
                if (formRef.current) {
                  const formData = new FormData(formRef.current);
                  const lgnPwd = formData.get("lgnPwd");

                  if (lgnPwd !== value) {
                    e.currentTarget.style.color = "red";
                    // e.currentTarget.setCustomValidity(
                    //   "비밀번호가 일치하지 않습니다."
                    // );
                    return;
                  }
                  if (lgnPwd === value) {
                    e.currentTarget.style.color = "#010101";
                    // e.currentTarget.setCustomValidity("");
                  }
                }
              }}
              validatyTxt="비밀번호가 일치하지 않습니다."
            />
          </li>
        </ul>
        <AllCheck />
        <div className="flex justify-center pt-[40px]">
          <button type="submit" className="btn bg-red-400">
            {t("btn_regi_cmm")}
          </button>
        </div>
      </form>
    </>
  );
}
